import { Flex, FlexItem } from "@patternfly/react-core";
import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { environment } from "../environment";
import { KeycloakProvider } from "./KeycloakContext";
import { PageNav } from "./PageNav";
//@ts-ignore
import { Grid } from "@l8/storybook";
import Loading from "./Loading";

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
const Header  = lazy(() =>
  delay(1500).then(() => import('./Header').then(module => ({ default: module.Header })))
);

export const Root = () => {
  return (
    <KeycloakProvider environment={environment}>
      <Suspense fallback={<Loading />}>
        <Header />
        <Flex flexWrap={{ default: "nowrap" }} spaceItems={{ default: "spaceItemsNone" }}>
          <FlexItem>
            <PageNav />
          </FlexItem>
          <FlexItem grow={{ default: "grow" }} alignSelf={{ default: "alignSelfFlexStart" }}>
            <Grid style={{ flexDirection: "column" }}>
              <Outlet />
            </Grid>
          </FlexItem>
        </Flex>
      </Suspense>
    </KeycloakProvider>
  );
};
